import axios from 'axios'

export const state = {
  types: {
    geofenceTypes: [],
    vehicleTypes: [],
    billingFrequencyTypes: [],
  },
}

export const getters = {
  geofenceTypes(state) {
    return state.types.geofenceTypes
  },
  vehicleTypes(state) {
    return state.types.vehicleTypes
  },
  billingPaymentTypes(state) {
    return state.types.billingFrequencyTypes
  },
}

export const mutations = {
  SET_GEOFENCE_TYPES(state, newValue) {
    state.types.geofenceTypes = newValue
  },
  SET_VEHICLE_TYPES(state, newValue) {
    state.types.vehicleTypes = newValue
  },
  SET_BILLING_FREQUENCY_TYPES(state, newValue) {
    state.types.billingFrequencyTypes = newValue
  },
}

export const actions = {
  async init({ dispatch }) {
    await dispatch('getGeofenceTypes')
    await dispatch('getBillingFrequencyTypes')
  },
  getVehicleTypes(params) {
    const { pageSize = 10, page = 1, sorts = null, filters = null } = params
    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)

    const url = `/tables/vehicleTypes?${query}`

    return axios.get(url)
  },
  getRateTypes() {
    const url = `/types/rate-types`

    return axios.get(url)
  },
  getPaymentTypes() {
    const url = `/types/payment-types`

    return axios.get(url)
  },
  getPaymentMethodTypes() {
    const url = `/types/payment-method-types`

    return axios.get(url)
  },
  getRefundPaymentMethodTypes() {
    const url = `/refund/paymentMethods`

    return axios.get(url)
  },
  getChargeTypes() {
    const url = `/types/charge-types`

    return axios.get(url)
  },
  getRefundTypes() {
    return axios.get(`/types/refund-types`)
  },
  async getBillingPaymentTypes() {
    let result = await axios.get(`/types/billing-payment-types`)
    if (result.data) {
      result.data = result.data.filter((paymentType) => paymentType.label !== 'Account Credit')
    }
    return result
  },
  getBillingFrequencyTypes({ commit }) {
    return axios.get(`/contracts/billingFrequencyTypes`).then((value) => {
      commit('SET_BILLING_FREQUENCY_TYPES', value.data)
    })
  },
  getTripTypes() {
    const url = `/types/trip-types`

    return axios.get(url)
  },
  getMarketRateTypes() {
    const url = `/types/market-rate-types`

    return axios.get(url)
  },
  getSocialMediaTypes() {
    const url = `/types/social-media-types`

    return axios.get(url)
  },
  getQuoteTypes() {
    const url = `types/quote-types`

    return axios.get(url)
  },
  getreferralRejectionReason() {
    const url = `/types/referral-rejection-reason-types`

    return axios.get(url)
  },
  getPartnerTypes(params) {
    const { pageSize = 15, page = 1, sorts = null, filters = null } = params
    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)

    const url = `/partnerTypes?${query}`

    return axios.get(url)
  },
  getEldTypes(params) {
    const { pageSize = -1, page = 1, sorts = null, filters = null } = params
    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)

    const url = `/tables/eldTypes?${query}`

    return axios.get(url)
  },
  async getGeofenceTypes({ commit }) {
    const url = `/types/geofence-type`
    const res = await axios.get(url)
    commit('SET_GEOFENCE_TYPES', res.data)
  },
  async setVehicleTypes({ commit }) {
    const pageSize = -1
    const page = 1
    let query = `page=${page}&pageSize=${pageSize}`
    query = encodeURI(query)

    const url = `/tables/vehicleTypes?${query}`

    const res = await axios.get(url)
    commit('SET_VEHICLE_TYPES', res.data.resultList)
  },
  getLeadTemperatureTypes(store, params) {
    const { pageSize = -1, page = -1, sorts = null, filters = null } = params

    let query = `page=${page}&pageSize=${pageSize}`

    query = encodeURI(query)
    const url = `/leadTemperatureTypes`
    return axios.get(url)
  },
  getRecurrenceTypes() {
    return axios.get(`/recurrenceTypes`)
  },
  getMarkupTypes() {
    const url = `/tables/markup-types`
    return axios.get(url)
  },
  getClassificationTypes() {
    const url = `/types/classification-type`
    return axios.get(url)
  },
  getCompanyCancellationTypes(params) {
    const queryString = Object.keys(params)
      .map((param) => {
        if (!params[param]) {
          return null
        }
        return `${param}=${encodeURIComponent(params[param])}`
      })
      .filter(Boolean)
      .join('&')

    const url = `/metrics/getCompanyCancellationTypes?${queryString}`
    return axios.get(url)
  },
  getMarketCancellationTypes(params) {
    const queryString = Object.keys(params)
      .map((param) => {
        if (!params[param]) {
          return null
        }
        return `${param}=${encodeURIComponent(params[param])}`
      })
      .filter(Boolean)
      .join('&')

    const url = `/metrics/getMarketCancellationTypes?${queryString}`
  },
  getNPSResponseTypes() {
    const url = `/types/nps-type`
    return axios.get(url)
  },
  getRiskTypes() {
    const url = `/riskType`
    return axios.get(url)
  },
  getMarketVehicleAvailabilityTypes(params) {
    const { pageSize = 10, page = 1, sorts = null, filters = null } = params
    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)

    const url = `/types/marketVehicleAvailability?${query}`

    return axios.get(url)
  },
}
